module.exports = "/assets/images/c6d8607dac9ec940ba4e8b73167b1b45.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_right_solid.svg
// module id = Xlpv
// module chunks = 0